import {StateProvider} from "@uirouter/angularjs";
import {UserConfigProvider} from "../types/UserConfig";
import {Transition} from "@uirouter/core/lib/transition/transition";
import {StockScreenerView} from "./view/StockScreenerViewComponent";
import {isOpenMarketsAppBranding} from "../types/Branding";

/** @ngInject */
export default function($stateProvider: StateProvider, userConfigProvider: UserConfigProvider) {
    const branding = userConfigProvider.config.branding;

    if (isOpenMarketsAppBranding(branding)) {
        $stateProvider.state("stock-screener", {
            url: "/stock-screener",
            component: StockScreenerView,
            data: {
                pageTitle: "Stock Screener"
            },
            params: {}
        });

        $stateProvider.state("trading-view-redirect", {
            url: "/trading-view/charting?tvwidgetsymbol",
            redirectTo: (transition: Transition) => {
                const params = transition.params();
                const symbol: string | null = params.tvwidgetsymbol;

                if ((symbol != null) && (symbol.indexOf(":") > -1)) {
                    const start = symbol.indexOf(":") + 1;
                    const code = symbol.substr(start);
                    return {
                        state: "charting",
                        params: {
                            symbol: code
                        }
                    };
                } else {
                    return {
                        state: "charting"
                    };
                }
            }
        });
    }
}
